module.exports = __webpack_public_path__ + "static/img/ydzz3.6d1d159.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bc/ydzz3.png
// module id = F3wz
// module chunks = 0